/*
 * 催收函pdf
 * *
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetUrgeLetterMapReq, DownloadUrgeLetterReq  } from "@/pbjs/xcommon/collection_pb";
import { Page } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";

export function getUrgeLetterMapReq(arg: any) {
    let request: any = new GetUrgeLetterMapReq();
    request.setCaselevel(arg.Caselevel);
    request.setOrderid(arg.Orderid);
    return request ;
}

export const getUrgeLetterMapReqRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.getUrgeLetterMap
);

export function getDownUrgeLetterReq(arg: any) {
    let request: any = new DownloadUrgeLetterReq();
    request.setLetterid(arg.Letterid );
    request.setOrderid(arg.Orderid);
    request.ExtraparamsMap = arg.Extraparams;
    return request ;
}

export const getDownUrgeLetterRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.downloadUrgeLetter
);

